<template>
  <div>
    <section role="dialog" tabindex="-1" aria-labelledby="modal-heading-01" aria-modal="true" aria-describedby="modal-content-id-1" :class="classes">
      <div class="slds-modal__container">
        <header class="slds-modal__header">
          <button class="slds-button slds-button_icon slds-modal__close" title="Close" @click="$emit('close')">
            <svg class="slds-button__icon slds-button__icon_large" aria-hidden="true">
              <use xlink:href="../assets/symbols.svg#close"></use>
            </svg>
            <span class="slds-assistive-text">{{$t('general.close')}}</span>
          </button>
          <h2 id="modal-heading-01" class="slds-modal__title slds-hyphenate">{{title}}</h2>
        </header>
        <div class="slds-modal__content slds-p-around_medium modal-content" id="modal-content-id-1" :style="`height: ${height};`">
        <slot />
      </div>
      <footer class="slds-modal__footer" :class="{'slds-modal__footer_directional': directional}" v-if="showFooter">
        <slot v-if="!destructiveButtonText && !positiveButtonText && !neutralButtonText" name="footer"></slot>
        <template v-else>
          <button class="slds-button slds-button_destructive" @click="$emit('destructiveButtonClick')" :disabled="destructiveButtonDisabled" v-if="destructiveButtonText">{{destructiveButtonText}}</button>
          <button class="slds-button slds-button_neutral2" @click="$emit('neutralButtonClick')" :disabled="neutralButtonDisabled" v-if="neutralButtonText">{{neutralButtonText}}</button>
          <button class="slds-button slds-button_brand" @click="$emit('positiveButtonClick')" :disabled="positiveButtonDisabled" v-if="positiveButtonText">{{positiveButtonText}}</button>
        </template>
      </footer>
    </div>
    </section>
    <div class="slds-backdrop slds-backdrop_open"></div>
  </div>
</template>
<script>
export default {
  computed: {
    classes () {
      const classes = ['slds-modal', 'slds-fade-in-open']
      if (this.size) {
        classes.push(`slds-modal_${this.size}`)
      }
      return classes.join(' ')
    }
  },
  props: {
    destructiveButtonDisabled: Boolean,
    destructiveButtonText: [Number, String],
    directional: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    neutralButtonDisabled: Boolean,
    neutralButtonText: [Number, String],
    positiveButtonDisabled: Boolean,
    positiveButtonText: [Number, String],
    showFooter: {
      type: Boolean,
      default: true
    },
    size: String,
    title: String
  }
}
</script>
<style lang="scss" scoped>
  .slds-modal__container{
    // height: auto;
    // max-width: 70vh;
    width: 80%;
  }
  .slds-modal__footer{
    display: inline !important;
  }
  .modal-content {
    height: auto;
    max-height: 60vh !important;
  }
</style>
